export const dnReturnPrintStatus = {
  PRINTED: "p",
  UNPRINTED: "u",
};

export default [
  { key: dnReturnPrintStatus.PRINTED, label: "Printed" },
  { key: dnReturnPrintStatus.UNPRINTED, label: "Unprinted" },
];
